module.exports = __webpack_public_path__ + "img/transpornet.3c0bb5ec.jpeg";